export default __webpack_public_path__ + "static/media/sav3.654bf411.jpg";